module.exports = __webpack_public_path__ + "static/media/simple-logo.2a226e7f.png";